export function admin(allProductsData) {
  return {
    type: 'ADMIN_ALL_PRODUCTS',
    allProductsData
  }
}